import { computed, inject, Injectable, signal } from '@angular/core';
import { PendingInviteDtoV2, UserEstablishmentsServiceV2 } from 'api-client';

@Injectable({
  providedIn: 'root',
})
export class PendingInvitationsStore {
  private readonly userEstablishmentsService = inject(UserEstablishmentsServiceV2);

  private readonly _invitations = signal<PendingInviteDtoV2[]>([]);
  private readonly _isLoading = signal(false);

  readonly invitations = this._invitations.asReadonly();
  readonly isLoading = this._isLoading.asReadonly();
  readonly count = computed(() => this._invitations().length);

  load(): void {
    this._isLoading.set(true);
    this.userEstablishmentsService.apiV2UserEstablishmentsInvitesPendingGet().subscribe({
      next: (response) => {
        this._invitations.set(response?.data ?? []);
        this._isLoading.set(false);
      },
      error: () => {
        this._invitations.set([]);
        this._isLoading.set(false);
      },
    });
  }

  removeInvitation(id: number): void {
    this._invitations.update((list) => list.filter((inv) => inv.id !== id));
  }

  clear(): void {
    this._invitations.set([]);
  }
}
